<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" :scrollbar="false" width="400px" @open="onOpen"
    @closed="onClosed">
    <el-form class="padding-lr" ref="form" :model="form" :rules="formRules" @submit.native.prevent>
      <el-form-item prop="taConfigName" label="TA Name">
        <el-input v-model="form.taConfigName" placeholder="Please input TA Name">
        </el-input>
      </el-form-item>
      <el-form-item prop="status" label="Status" required>
        <div style="width: 100%;float: left"><el-switch v-model="form.status" active-color="#d52b1e"
            inactive-color="#f2f3f6">
          </el-switch>
          {{ form.status ? '可用' : '不可用' }}</div>

      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onSave" :loading='submitLoading'> Save </el-button>
      <el-button @click="dialogVisible = false"> Cancel </el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: "EditConfigDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
    taInfoTitle: String,
    taInfoForm: Object
  },
  data() {
    return {
      submitLoading: false,
      title: '',
      dialogVisible: this.visible,
      form: {
        taConfigId: "",
        taConfigName: '',
        status: true
      },
      formRules: {
        taConfigName: [
          {
            required: true,
            tigger: "blur",
            validator: "Please input TA Name",
          },
        ],
      },
    };
  },
  watch: {
    visible(value) {
      this.dialogVisible = value;
    },
  },
  methods: {
    onSave() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let apiUrl = ''
          if (this.title == 'Add TA') {
            apiUrl = '/sys/addTa?'
          } else {
            apiUrl = '/sys//updateTa'
          }
          this.submitLoading = true
          this.axios
            .post(apiUrl, {
              ...this.form,
              status: this.form.status ? 1 : 0
            })
            .then(({ code, msg }) => {
              this.submitLoading = false
              if (code === 200) {
                this.$emit('success')
                this.$message.success(`${this.title} successfully`);
                this.dialogVisible = false;
              } else {
                this.$message.error(msg);
              }
            });
        } else {
          return false;
        }
      });
    },
    onOpen() {
      this.title = this.taInfoTitle
      this.form = {
        ...this.form,
        ...this.taInfoForm,
        status: this.taInfoForm.status == 1 ? true : false
      }
    },
    onClosed() {
      this.$refs.form.resetFields();
      this.$emit("update:visible", false);
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .el-dialog__body {
    padding: 0 10px 10px !important;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
  }
}

.el-form {
  width: 100%;
}

.dialog-footer {
  text-align: center;
}

.video-size {
  margin-left: 10px;
}

.el-icon-view {
  color: #909399;
  font-size: 14px;
  cursor: pointer;

  &:hover,
  &.active {
    color: $theme-color;
  }
}
</style>
